import crypto from "crypto";

export const encrypt = (text) => {
    const iv = crypto.randomBytes(Number(process.env.REACT_APP_ENCRYPTION_IV_LENGTH))
    const cipher = crypto.createCipheriv(
        'aes-256-cbc',
        Buffer.from(process.env.REACT_APP_ENCRYPTION_KEY),
        iv,
    )
    const encrypted = cipher.update(text)
    return (
        iv.toString('hex') +
        ':' +
        Buffer.concat([encrypted, cipher.final()]).toString('hex')
    )
}